import React from 'react'
import "./StepsContainer.css"
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { stepsActions } from '../../../store/steps-slice'

const StepsContainer = (props) => {
  const { step, step2, step3, step4, heading1, heading2, heading3, heading4 } = props
  const dispatch=useDispatch();

  return (
    <div id='stepsContainer' className={step===4 ? 'step4Container' : ''}>
      <div className='stepsContainer-ChooseProduct'>
        <div>
          <h6 className='stepHeading'>{(step === 1 && heading1) || (step === 2 && heading2) || (step === 3 && heading3) || (step === 4 && heading4)}</h6>
          {step === 1 ? '' : <p className="stepNumber"> (Step {(step === 2 && step2) || (step === 3 && step3) || (step === 4 && step4)} of 3)</p>}
        </div>
        {step===2 && <span className='createNewProduct'>
          <img className='createNewProductImg' src='https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/add.svg' alt="add-icon" />
          <Link to="/products/add-new-product" className="createNewProductLink" onClick={()=>dispatch(stepsActions.handleRedirection(true))}>Add new Product</Link>
        </span>}
      </div>
      <hr className='stepsHr' />
      {props.children}
    </div>
  )
}

export default StepsContainer